export default __webpack_public_path__ + "static/media/muffler.754fea5c.png";